const { render, define, h, Component } = omii;

const loadStyleSheet = async (css) => {
  return fetch(getStyleSheetUrl(css)).then((r) => r.text());
};
const addStyleSheet = async (css, parent) => {
  let $link = <link rel="styleSheet" href={getStyleSheetUrl(css)}></link>;
  render($link, parent ?? "body");
};
const addRebootStyleSheet = async () => {
  addStyleSheet("reboot");
};
const getStyleSheetUrl = (css) => {
  return new URL(`./css/${css}.css`, import.meta.url).href;
};
const CSSStyleSheetMap = new Map();

const getCSSStyleSheet = async (css) => {
  if (CSSStyleSheetMap.has(css)) return CSSStyleSheetMap.get(css);
  let styleSheet = new CSSStyleSheet();
  styleSheet.replaceSync(await loadStyleSheet(css));
  CSSStyleSheetMap.set(css, styleSheet);
  return styleSheet;
};

export default {
  styleSheets: ["button", "reboot", "scrollbar"],
  loadStyleSheet,
  addStyleSheet,
  addRebootStyleSheet,
  getStyleSheetUrl,
  getCSSStyleSheet,
};
